import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';
import { getTimeStamp } from '../webcommon/common/helpers';

export const INITIAL_STATE = {
    columnsForIndependentAmount: constants.independentAmountColumns,
    defaultFilters: constants.defaultFilters,
    filterDefinitions: constants.filterDefinitions,
    runDate: '',
    initialisedIndependentAmount: false,
    fileLoading: false,
    loadingIndependentAmount: false,
    loadError:false,
    loadSuccess:false,
    currentServerFilters: null,
    isValidated: false,
    validationError: '',
    isUploaded: false,
    waitingForNotification: false,
    rowsIndependentAmount: [],
    downgrade: {
        available: false,
        fileName: '',
        isArchived: false,
        folder:''
    },
    otcIa: {
        available: false,
        fileName: '',
        isArchived: false,
        folder:''
    },     
    lastUpdatedIndependentAmount: getTimeStamp(),
    gridSorting: [{ gridId: 'timestampSort', gridSort: [{ id: 'createdAt', desc: true }] }]
};
const setRunDate = fp.set('runDate');
const setIndependentAmountInitialised = fp.set('initialisedIndependentAmount');
const setIndependentAmountLoading = fp.set('loadingIndependentAmount');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_RUNDATE:
            return setRunDate(action.date, state);              
        case actions.SET_INDEPENDENT_AMOUNT_INITIALISED:
            return setIndependentAmountInitialised(action.initialised, state);
        case actions.SET_INDEPENDENT_AMOUNT_LOADING:
            return setIndependentAmountLoading(action.loading, state);     
        case actions.GET_INDEPENDENT_AMOUNT_SUCCESS:{
            return {
                ...state,
                rowsIndependentAmount: action.result,
                lastUpdatedIndependentAmount: getTimeStamp()
            };
        }
        case actions.GET_IA_REPORTS_STATUS_SUCCESS:{
            return {
                ...state,
                downgrade: action.result1,
                otcIa: action.result2
            };
        }
        case actions.SET_ROW_CHECKED: {
            return {
                ...state,
                rowsIndependentAmount: state.rowsIndependentAmount
                    .map(row => (row.id !== action.id ? row
                        : fp.set('selected', action.checked, row)))
            };
        }
        case actions.SET_ALL_ROWS_CHECKED: {
            return {
                ...state,
                rowsIndependentAmount: state.rowsIndependentAmount
                    .map(row => fp.set('selected', action.checked, row))
            };
        }
        case actions.SET_GRID_SORTS: {
            const alreadyExists = state.gridSorting.find(sort => sort.gridId === action.gridId);
            if (!alreadyExists) {
                return {
                    ...state,
                    gridSorting: state.gridSorting.concat({
                        gridId: action.gridId,
                        gridSort: action.sorting
                    })
                };
            }

            return {
                ...state,
                gridSorting: state.gridSorting.map(
                    sort => (sort.gridId === action.gridId ? fp.set('gridSort', action.sorting, sort) : sort)
                )
            };
        }
        default:
            return state;
    }
}
